import { $$ } from "@utils/select";
import Flickity from "flickity";
import { listen } from "@utils/bph";

const FIX = "flickity-flex";

export default (sliderOptions = {}) => {
  let slider = null;

  const options = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: "left",
    contain: true,
    ...sliderOptions,
  };

  return {
    $$slides: null,

    init() {
      this.$$slides = $$('[x-ref="slide"]', this.$el);
      this.$refs.slider.classList.add(FIX);
      if (this.$$slides.length > 1) {
        listen("md", ({ matches }) => {
          if (matches) {
            this.destroySlider();
            return;
          }

          this.initSlider();
        });
      }
    },

    initSlider() {
      slider = new Flickity(this.$refs.slider, options);
    },

    destroySlider() {
      if (slider) slider.destroy();
    },
  };
};
